import React from 'react';
import MinimalResumePersonalInformation from './MinimalResumePersonalInformation';
import MinimalResumeSummary from "./MinimalResumeSummary";
import MinimalResumeHobbies from "./MinimalResumeHobbies";
import MinimalResumeCustom from "./MinimalResumeCustom";
import MinimalResumeEmployment from './MinimalResumeEmployment';
import MinimalResumeEducation from "./MinimalResumeEducation";
import MinimalResumeReference from "./MinimalResumeReference";
import MinimalResumeSkills from "./MinimalResumeSkills";
import MinimalResumeLanguage from "./MinimalResumeLanguage";

export default class MinimalResume extends React.Component {
    getAllOtherParts() {

        let otherForms = []
        for (let i = 0; i < this.props.resumeData.otherForms.length; i++) {
            let form = this.props.resumeData.otherForms[i];
            switch (form.type) {
                case 'summary':
                    otherForms.push(<MinimalResumeSummary title={form.title} data={form.data} key={i} />);
                    break;
                case 'hobbies':
                    otherForms.push(<MinimalResumeHobbies title={form.title} data={form.data} key={i} />);
                    break;
                case 'custom':
                    otherForms.push(<MinimalResumeCustom title={form.title} data={form.data} key={i} />);
                    break;
                case 'employment':
                    otherForms.push(<MinimalResumeEmployment title={form.title} data={form.data} key={i} />);
                    break;
                case 'education':
                    otherForms.push(<MinimalResumeEducation title={form.title} data={form.data} key={i} />);
                    break;
                case 'references':
                    otherForms.push(<MinimalResumeReference title={form.title} data={form.data} key={i} />);
                    break;
                case 'skills':
                    otherForms.push(<MinimalResumeSkills title={form.title} data={form.data} key={i} />);
                    break;
                case 'languages':
                    otherForms.push(<MinimalResumeLanguage title={form.title} data={form.data} key={i} />);
                default:
                // Do nothing;
            }
        }
        return otherForms;
    }
    render() {
        return <div data-v-b8233322="" className="container">
            <MinimalResumePersonalInformation
                title={this.props.resumeData.personalDetailForm.data.title}
                data={this.props.resumeData.personalDetailForm.data} />
            {this.getAllOtherParts()}
        </div>;
    }
}